import * as React from "react";
import { cn } from "@/lib/cn";

export function EmptyState({
  title,
  description,
  action,
  className,
}: {
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-line-1 bg-bg-2/40 px-6 py-12 text-center",
        className,
      )}
    >
      <p className="text-sm font-semibold text-t-1">{title}</p>
      {description && (
        <p className="max-w-md text-xs text-t-3">{description}</p>
      )}
      {action}
    </div>
  );
}
